<template>
    <v-autocomplete
        :label             = "$t('disposition.inspection.technician.label')"
        :items             = "dispatcher"
        item-value         = "id"
        item-text          = "name"
        v-model            = "user"
        :return-object     = true
        :clearable         = "true"
        :auto-select-first = "true"
        :outlined          = "outlined"
        :dense             = "dense"
        hide-details
        flat
        hide-no-data
        autocomplete  = "off"
        autocorrect   = "off"
        autocapitalize= "off"
        spellcheck    = "false"
        @input = "onInput"
    >
    </v-autocomplete>
</template>

<script>
export default {
    name: "FDispatcherSelect",

    props: {
        value: {

        },

        outlined: {
            required: false,
            type    : Boolean,
            default : function () {
                return false;
            }
        },

        dense: {
            required: false,
            type    : Boolean,
            default : function () {
                return false;
            }
        }
    },

    data: () => ({
        user: null
    }),

    computed: {
        dispatcher () {
            return this.$store.getters.msd.dispatcher;
        },
    },

    mounted() {
        this.user = this.value;
    },

    watch: {
        value () {
            this.user = this.value;
        }
    },

    methods: {
        onInput () {
            this.$emit("input", this.user);
        }
    }
}
</script>

<style scoped>

.dispatcher-select {
    max-width: 250px;
    width: 250px;
}

::v-deep .v-select__slot {
    margin-top: -2px;
}

</style>